import { useCallback } from 'react';

export interface IUseOnIntersectionProps {
  onTopStuck?: (isIntersecting: boolean) => void;
  onBottomStuck?: (isIntersecting: boolean) => void;
}

export const useOnIntersection = (props: IUseOnIntersectionProps) => {
  const { onBottomStuck, onTopStuck } = props;

  return useCallback(
    (sentinelClientRect: DOMRect) => {
      switch (true) {
        case sentinelClientRect.y === 0: {
          onBottomStuck?.(false);
          onTopStuck?.(true);
          break;
        }
        case sentinelClientRect.y + sentinelClientRect.height >= window.innerHeight: {
          onBottomStuck?.(true);
          onTopStuck?.(false);
          break;
        }
        default: {
          onBottomStuck?.(false);
          onTopStuck?.(false);
        }
      }
    },
    [onBottomStuck, onTopStuck],
  );
};
